<div class="modal-footer-2"><ng-content></ng-content></div>
